import React, { useState } from "react";
import clsx from "clsx";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Chip,
    CircularProgress,
    Divider,
    Grid,
    IconButton,
    makeStyles,
    Modal,
    Typography,
} from "@material-ui/core";
import black from "../../black.jpg";
import modalImage from "../../icons/auth_info.png";
import {
    AddBox,
    Camera,
    Clear,
    Close,
    Comment,
    Favorite,
    RemoveRedEye,
} from "@material-ui/icons";
import { RouteComponentProps, withRouter } from "react-router";
import Cookies from "js-cookie";
import config from "../../config/apiConfig";

const useStyles = makeStyles((theme) => ({
    root: {
        width: 138,
    },
    media: {
        height: 172,
        position: "relative",
    },
    percent: {
        float: "right",
        margin: "8px 8px 0 0",
    },
    heading: {
        maxWidth: 138,
        marginTop: 8,
        marginBottom: 4,
        fontWeight: "bold",
    },
    flex: {
        maxWidth: 138,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    flex2: {
        display: "flex",
        alignItems: "center",
    },
    subtitle: {
        color: "#797979",
        fill: "#797979",
    },
    card: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        outline: "none",
        boxShadow: theme.shadows[20],
        width: 700,
        maxHeight: "100%",
        overflowY: "auto",
        maxWidth: "100%",
        display: "flex",
        "& > *": {
            flexGrow: 1,
            flexBasis: "50%",
            width: "50%",
        },
    },
    cardMedia: {
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
        padding: theme.spacing(3),
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        [theme.breakpoints.down("md")]: {
            display: "none",
        },
    },
    close: {
        position: "absolute",
        top: theme.spacing(1),
        right: theme.spacing(1),
        width: "min-content",
        backgroundColor: "#eee",
    },
}));

export type Story = {
    storyId: string;
    title: string;
    shortDesc: string;
    imageUrl: string;
    totalClick: number;
    totalLike: number;
    totalComments: number;
    storyRating: number;
    criticsRating: number;
    storyBotRating: number;
    score: number;
    chapterCount: number;
    tags: string[];
};

type Props = Story & {
    onRemove?: () => void;
    style?: React.CSSProperties;
};

const StoryCardSmall: React.FC<Props & RouteComponentProps> = (props) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [adding2SL, setAdding2SL] = useState(false);
    const [added2SL, setAdded2SL] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        if (added2SL && props.onRemove) {
            props.onRemove();
        }
        setOpen(false);
    };

    const handleRead = () => {
        const formData = new FormData();
        formData.append("storyId", props.storyId);
        const requestOptions: RequestInit = {
            method: "POST",
            body: formData,
            headers: {
                "Access-Control-Allow-Origin": "*",
                session_token: Cookies.get("token") ?? "",
                token: config.token,
            },
        };
        fetch(config.BASE_URL + "/v2/api/interaction/click", requestOptions)
            .then((res) => res.json())
            .then((res) => console.log(res))
            .catch((error) => console.error(error));
        props.history.push("/producer/story/" + props.storyId);
    };

    const add2SL = () => {
        setAdding2SL(true);
        const requestOptions: RequestInit = {
            method: "POST",
            body: null,
            headers: {
                "Access-Control-Allow-Origin": "*",
                session_token: Cookies.get("token") ?? "",
                token: config.token,
            },
        };
        fetch(
            config.BASE_URL + "/v2/api/shortlist/add?storyId=" + props.storyId,
            requestOptions
        )
            .then(() => setAdded2SL(true))
            .finally(() => setAdding2SL(false));
    };

    const removeFromSL = () => {
        setAdding2SL(true);
        const requestOptions: RequestInit = {
            method: "POST",
            body: null,
            headers: {
                "Access-Control-Allow-Origin": "*",
                session_token: Cookies.get("token") ?? "",
                token: config.token,
            },
        };
        fetch(
            config.BASE_URL +
                "/v2/api/shortlist/delete?storyId=" +
                props.storyId,
            requestOptions
        )
            .then(() => setAdded2SL(false))
            .finally(() => setAdding2SL(false));
    };

    return (
        <React.Fragment>
            <div style={props.style} onClick={handleOpen}>
                <Card className={classes.root}>
                    <CardMedia
                        className={classes.media}
                        image={
                            !!props.imageUrl
                                ? "https://apis.serendipitymedia.tech/assets/" +
                                  props.imageUrl
                                : black
                        }
                    >
                        <Chip
                            className={classes.percent}
                            size="small"
                            icon={<Camera fontSize="small" />}
                            label={`${props.score}%`}
                            color="secondary"
                        />
                        <Box
                            width="max-content"
                            borderRadius={4}
                            paddingY={0.5}
                            paddingX={1}
                            fontSize={14}
                            position="absolute"
                            bottom={8}
                            left={8}
                            bgcolor={"#eee"}
                        >
                            {props.chapterCount} parts
                        </Box>
                    </CardMedia>
                </Card>
                <Typography noWrap className={classes.heading}>
                    {props.title}
                </Typography>
                <div className={clsx(classes.flex, classes.subtitle)}>
                    {/* <Typography variant="subtitle2">
                        {props.timeToRead} hours read
                    </Typography> */}
                    <Typography variant="subtitle2">
                        <RemoveRedEye fontSize="small" /> {props.totalClick}
                    </Typography>
                </div>
            </div>
            <Modal open={open} onClose={handleClose}>
                <Card className={classes.card}>
                    <IconButton
                        size="small"
                        className={classes.close}
                        onClick={() => setOpen(false)}
                    >
                        <Close />
                    </IconButton>
                    <CardMedia
                        className={classes.cardMedia}
                        image={
                            !!props.imageUrl
                                ? "https://apis.serendipitymedia.tech/assets/" +
                                  props.imageUrl
                                : modalImage
                        }
                    ></CardMedia>
                    <CardContent>
                        <Typography
                            variant="h6"
                            style={{
                                fontWeight: "bold",
                                maxHeight: "3em",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                marginRight: 32,
                            }}
                        >
                            {props.title}
                        </Typography>
                        <Typography
                            className={classes.subtitle}
                            variant="subtitle2"
                        >
                            {props.chapterCount} Parts
                        </Typography>
                        <Typography
                            variant="body1"
                            component="p"
                            style={{
                                margin: "12px 0",
                                maxHeight: "6em",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {props.shortDesc}
                        </Typography>
                        <Divider />
                        <Grid
                            container
                            spacing={2}
                            style={{ marginTop: 4, marginBottom: 8 }}
                        >
                            <Grid item>
                                <Typography
                                    variant="subtitle1"
                                    style={{ fontWeight: "bold" }}
                                >
                                    Pencil Score:
                                </Typography>
                                <div className={classes.flex2}>
                                    <Camera color="secondary" />{" "}
                                    <Typography color="secondary">
                                        {props.score}%
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item>
                                <Typography
                                    variant="subtitle1"
                                    style={{ fontWeight: "bold" }}
                                >
                                    Engagement:
                                </Typography>
                                <div
                                    className={clsx(
                                        classes.flex,
                                        classes.subtitle
                                    )}
                                >
                                    <Typography
                                        className={classes.flex2}
                                        variant="subtitle2"
                                    >
                                        <RemoveRedEye fontSize="small" />{" "}
                                        {props.totalClick}
                                    </Typography>
                                    &nbsp;&nbsp;
                                    <Typography
                                        className={classes.flex2}
                                        variant="subtitle2"
                                    >
                                        <Favorite fontSize="small" />{" "}
                                        {props.totalLike}
                                    </Typography>
                                    &nbsp;&nbsp;
                                    <Typography
                                        className={classes.flex2}
                                        variant="subtitle2"
                                    >
                                        <Comment fontSize="small" />{" "}
                                        {props.totalComments}
                                    </Typography>
                                </div>
                            </Grid>
                        </Grid>
                        <Divider />
                        {props.tags.length > 0 && (
                            <React.Fragment>
                                <Grid
                                    container
                                    spacing={1}
                                    style={{ margin: "8px 0" }}
                                >
                                    {props.tags.map((t, i) => (
                                        <Grid item key={i}>
                                            <Chip label={t} />
                                        </Grid>
                                    ))}
                                </Grid>
                                <Divider />
                            </React.Fragment>
                        )}
                        <Box className={classes.flex2} marginTop={1}>
                            {adding2SL ? (
                                <CircularProgress color="secondary" />
                            ) : (
                                <React.Fragment>
                                    <IconButton
                                        onClick={
                                            added2SL ? removeFromSL : add2SL
                                        }
                                    >
                                        {added2SL ? <Clear /> : <AddBox />}
                                    </IconButton>
                                    <Typography
                                        variant="subtitle1"
                                        style={{ fontWeight: "bold" }}
                                    >
                                        {added2SL
                                            ? "Remove from shortlist"
                                            : "Shortlist this story"}
                                    </Typography>
                                </React.Fragment>
                            )}
                        </Box>
                        <Box display="flex" marginTop={3}>
                            <Button
                                variant="contained"
                                style={{ textTransform: "none" }}
                                onClick={handleRead}
                            >
                                Read
                            </Button>
                            <Box width={12} />
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                style={{ textTransform: "none" }}
                            >
                                Buy for ₹2,999
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Modal>
        </React.Fragment>
    );
};

export default withRouter(StoryCardSmall);
